import * as React from "react";
import LeadStatus from "../../../../model/lead/LeadStatus";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import EditLeadStatusFormView from "./EditLeadStatusFormView";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {editLeadStatus} from "../../../../store/action/leadStatus/leadStatus";
import {connect} from "react-redux";

interface IComponentProps {
	/**
	 * On successful edited lead status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Lead status to edit
	 */
	editedLeadStatus: LeadStatus;
}

interface IDispatchProps {
	/**
	 * Update lead status.
	 * @param {LeadStatus} data
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateLeadStatus: (data: LeadStatus, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditLeadStatusForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditLeadStatusFormView onSubmit={this.onSubmit}
									onCancel={this.props.onCancel}
									isSubmitting={this.state.isSubmitting}
									editedLeadStatus={this.props.editedLeadStatus}/>
		);
	}

	onSubmit(data: LeadStatus) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateLeadStatus(
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success("Lead status updated", "Lead status update");
						this.props.onSuccess();
					});
				},
				() => {
					this.setState({isSubmitting: false},
						() => Toast.error("Sorry, something went wrong. Try again later.", "Lead status update"));
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateLeadStatus: (data: LeadStatus, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(editLeadStatus(props.editedLeadStatus.id, data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(EditLeadStatusForm);
